(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function attachCheckboxListener() {
  var checkbox = document.getElementById('signup-checkbox-footer');
  var submitButton = document.getElementById('FooterSubscribe');

  if (checkbox && submitButton) {
    checkbox.removeEventListener('change', toggleSubmitButton);
    checkbox.addEventListener('change', toggleSubmitButton);

    submitButton.disabled = !checkbox.checked;
  }
}

function toggleSubmitButton() {
  var submitButton = document.getElementById('FooterSubscribe');
  if (submitButton) {
    submitButton.disabled = !this.checked;
  }
}

document.addEventListener('DOMContentLoaded', attachCheckboxListener);
document.addEventListener('shopify:section:select', attachCheckboxListener);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    const marginDesktopValue = this.getAttribute('data-margin-desktop');
    // Fetch data-margin-desktop and calculate percentage
    this.marginDesktopPercentage = parseFloat(marginDesktopValue) || 2; 
    this.marginDesktopThreshold = this.marginDesktopPercentage*2 / 100; 

    const marginMobileValue = this.getAttribute('data-margin-mobile');
    this.marginMobilePercentage = parseFloat(marginMobileValue) || 2; 
    this.marginMobileThreshold = this.marginMobilePercentage / 300; 

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 250; 
    const viewportWidth = window.innerWidth;
    let resetOffset;

    if (viewportWidth < 990) {
      resetOffset = window.innerHeight * this.marginMobileThreshold;
    } else {
      // Using desktop threshold
      resetOffset = window.innerHeight * this.marginDesktopThreshold;
    }
    
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top + resetOffset) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden');
    this.header.classList.remove('shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  function initIntersectionObserver() {
  const headers = document.querySelectorAll('.enable-fixed-header-part--true.enable-header-full-width--false');

  if (!headers.length) return; // Ensure there are elements to observe

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target); 
      }
    });
  }, { threshold: 1 });

  headers.forEach(header => {
    observer.observe(header);
  });
}

initIntersectionObserver();

document.addEventListener('shopify:section:load', () => {
  initIntersectionObserver();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-donation-desktop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pv-donation-desktop')) {
    customElements.define('pv-donation-desktop', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.amount = this.querySelector('[data-pv-amount]');
        this.status = this.querySelector('[data-pv-status]');
        this.live = this.querySelector('[data-pv-live]');
        this.liveLabel = this.querySelector('[data-pv-live-label]');
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.inView = false;
        this.lastSuccess = Date.now();
        this.locale = document.documentElement.lang || 'de-DE';
        this.moneyFormat = new Intl.NumberFormat(this.locale, { style: 'currency', currency: 'EUR' });
        this.dateFormat = new Intl.DateTimeFormat(this.locale, { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
        this.onActivity = () => this.syncActivity();
        this.desktop.addEventListener('change', this.onActivity);
        document.addEventListener('visibilitychange', this.onActivity);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting);
          this.syncActivity();
        });
        this.observer.observe(this);
        this.acceptValue(this.amount);
      }

      disconnectedCallback() {
        this.initialized = false;
        window.clearTimeout(this.timer);
        this.controller?.abort();
        this.observer?.disconnect();
        this.desktop?.removeEventListener('change', this.onActivity);
        document.removeEventListener('visibilitychange', this.onActivity);
      }

      isActive() {
        return this.isConnected && this.desktop.matches && !document.hidden && this.inView;
      }

      syncActivity() {
        window.clearTimeout(this.timer);
        if (!this.isActive()) {
          this.controller?.abort();
          return;
        }
        this.refresh();
      }

      setLive(active) {
        if (this.live) this.live.dataset.active = String(active);
        if (this.liveLabel) this.liveLabel.textContent = active ? 'Live' : 'Gesammelt';
      }

      acceptValue(source) {
        const rawCents = source?.dataset.totalCents || '';
        const cents = Number(rawCents);
        const timestamp = Date.parse(source?.dataset.updatedAt || '');
        if (source?.dataset.state !== 'ready' || source.dataset.currency !== 'EUR' || !/^\d+$/.test(rawCents) || !Number.isSafeInteger(cents) || cents < 0 || !Number.isFinite(timestamp) || timestamp > Date.now() + 300000) {
          return false;
        }
        const formatted = this.moneyFormat.format(cents / 100);
        this.amount.textContent = formatted;
        this.amount.style.setProperty('--pv-digits', String(formatted.length));
        this.amount.dataset.state = 'ready';
        this.amount.dataset.totalCents = rawCents;
        this.amount.dataset.updatedAt = source.dataset.updatedAt;
        this.amount.dataset.automatic = source.dataset.automatic;
        this.setLive(source.dataset.automatic === 'true' && Date.now() - timestamp >= 0 && Date.now() - timestamp <= 900000);
        this.lastSuccess = Date.now();
        this.status.classList.toggle('is-alert', Date.now() - timestamp > 900000);
        this.status.textContent = Date.now() - timestamp > 900000
          ? this.dataset.staleText
          : `${this.dataset.updatedLabel} ${this.dateFormat.format(timestamp)}`;
        return true;
      }

      async refresh() {
        if (!this.isActive() || this.controller) return;
        const controller = new AbortController();
        this.controller = controller;
        const timeout = window.setTimeout(() => controller.abort(), 12000);
        try {
          const url = new URL(window.location.href);
          url.hash = '';
          url.searchParams.delete('sections');
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('_pv_donation', String(Date.now()));
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
          if (!response.ok) throw new Error('Section unavailable');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = Array.from(documentFragment.querySelectorAll('pv-donation-desktop')).find(item => item.dataset.sectionId === this.dataset.sectionId);
          if (!this.acceptValue(section?.querySelector('[data-pv-amount]'))) {
            this.setLive(false);
            this.status.classList.add('is-alert');
            if (this.amount.dataset.state === 'ready') this.status.textContent = this.dataset.staleText;
            else this.status.textContent = this.dataset.unavailableText;
          }
        } catch {
          this.setLive(false);
          if (this.isActive()) {
            if (this.amount.dataset.state !== 'ready') this.status.textContent = this.dataset.unavailableText;
            else if (Date.now() - this.lastSuccess >= 90000) {
              this.status.classList.add('is-alert');
              this.status.textContent = this.dataset.staleText;
            }
          }
        } finally {
          window.clearTimeout(timeout);
          if (this.controller === controller) this.controller = null;
          if (this.isActive()) this.timer = window.setTimeout(() => this.refresh(), 30000);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
